var map = {
	"./b2b_loan.png": "9e40",
	"./buy_now.png": "3936",
	"./cash_in.png": "e2d3",
	"./cash_management.png": "7157",
	"./digital_product.png": "2cb3",
	"./digital_wallet.png": "2730",
	"./ekyc.png": "2c54",
	"./gold_saving.png": "afe8",
	"./kaspro.png": "a55e",
	"./qris_payment.png": "462c",
	"./remittance.png": "3303",
	"./vcn.png": "b91d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2eb3";